import { Box, Container, Stack } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { Header, Loader, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { ContainerJourneyReportTableFilters } from './components/organism/ContainerJourneyReportTableFilters'
import { ContainerReportTable } from './components/tables/ContainerReportTable'

export const ContainersReport = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const { containerJourneyReportViewStore } = usePlanningStore()

  const title = t('containerJourneys', 'Container Journeys')
  const breadcrumbs = [
    { label: t('reports', 'Reports'), route: PATHS?.reportsV2.url },
    { label: title },
  ]

  useEffect(() => {
    return () => {
      containerJourneyReportViewStore.reset()
    }
  }, [containerJourneyReportViewStore])

  return (
    <Box sx={{ height: '100%', bgcolor: theme.palette.grey[100] }}>
      <Header title={title} breadcrumbs={breadcrumbs} />

      <Container sx={{ paddingY: theme.customSpacing.m }} maxWidth={false}>
        <Stack spacing={theme.customSpacing.m}>
          <ContainerJourneyReportTableFilters store={containerJourneyReportViewStore} />

          {containerJourneyReportViewStore.isLoading && <Loader show />}

          {!containerJourneyReportViewStore.isLoading &&
            containerJourneyReportViewStore.hasFetched && (
              <ContainerReportTable data={containerJourneyReportViewStore.reportData} />
            )}
        </Stack>
      </Container>
    </Box>
  )
})
